import { AxiosError } from 'axios';
import { toast } from 'react-hot-toast';

import { devLog } from './helpers';

type ApiErrorResponse = {
  status: number;
  message: string;
};

const isApiErrorResponseData = (data: unknown) =>
  typeof data === 'object' &&
  (data as Partial<ApiErrorResponse>)?.status &&
  (data as Partial<ApiErrorResponse>)?.message;

export const handleError = (error: unknown) => {
  let message = 'Something went wrong';

  devLog(error);

  if (!error) {
    // keep default message
  } else if (typeof error === 'string') {
    message = error;
  } else if (error instanceof AxiosError) {
    // Handle 429 errors
    if (error.response?.status === 429) {
      message = '429 - Too many requests';
    }

    // Handle generic API error response coming from the cs-backend
    if (isApiErrorResponseData(error.response?.data)) {
      message = error.response?.data?.message || 'Something went wrong';

      // Handle specific strangely worded blockchain error, replace with more user friendly message
      if (message === 'Incoming transaction fee is not sufficient to replace existing transaction') {
        message = 'Another action is still processing';
      }
    }

    // Handle generic errors
  } else if (error instanceof Error) {
    message = error.message;

    // Stringify any other miscellaneous errors
  } else {
    message = JSON.stringify(error);
  }

  toast.error(typeof message === 'string' ? message : JSON.stringify(message));
};
